













import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
})
export default class SwAppResponsiveFooter extends Vue {
  cssPrefix: String = 'sw-app-responsive-footer';
}
